'use client';

import { useSyncExternalStore } from 'react';

const ACK_KEY = 'bazak_cookie_notice_ack';
const listeners = new Set<() => void>();
// Session-scoped fallback for private-mode / quota errors where localStorage
// throws. Without this, the catch blocks below can't record the dismissal and
// the banner stays visible after the user clicks "I understand".
let acknowledgedInMemory = false;

function read(): boolean {
  if (acknowledgedInMemory) return true;
  try {
    return localStorage.getItem(ACK_KEY) === '1';
  } catch {
    return false;
  }
}

function subscribe(onChange: () => void): () => void {
  listeners.add(onChange);
  return () => {
    listeners.delete(onChange);
  };
}

// Server + first-paint assume acknowledged so dependent UI (banner, BackToTop
// adjustments) doesn't flash; the client re-reads via useSyncExternalStore
// post-hydration, keeping SSR and hydrated markup matched.
function getServerSnapshot() {
  return true;
}

export function useCookieAcknowledged(): boolean {
  return useSyncExternalStore(subscribe, read, getServerSnapshot);
}

export function acknowledgeCookies() {
  acknowledgedInMemory = true;
  try {
    localStorage.setItem(ACK_KEY, '1');
  } catch {
    // Fall through — dismissal survives the session via acknowledgedInMemory.
  }
  listeners.forEach(l => l());
}
